import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import ComingSoon from './ComingSoon';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <ComingSoon />
  </StrictMode>,
);
